import { useContext, useEffect, useRef, useState } from "react"
import dataApplicationsContext from "../../context/dataApplicationsContext"
import { useGetAllUsersForPresenceQuery } from "../../slices/usersApiSlice";
import { SyncLoader } from "react-spinners";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMars, faVenus } from "@fortawesome/free-solid-svg-icons";

const getPhoneIcon = (lib) => {
  const clean = lib?.toLowerCase().trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '') || '';
  if (clean === 'pere') return faMars;
  if (clean === 'mere') return faVenus;
  return null;
}

const TelLine = ({ tel, keyId }) => {
  const labelRef = useRef(null);
  const [isTruncated, setIsTruncated] = useState(false);
  const icon = getPhoneIcon(tel.lib_telephone);

  useEffect(() => {
    const measure = () => {
      if (labelRef.current) {
        setIsTruncated(labelRef.current.scrollWidth > labelRef.current.clientWidth);
      }
    };
    // Double rAF : laisse le temps au layout/police de se stabiliser avant de mesurer
    requestAnimationFrame(() => requestAnimationFrame(measure));
  }, [tel.lib_telephone]);

  return (
    <a 
      key={keyId} href={`tel:${tel.phone_number}`}
      className={`tel-line ${isTruncated ? 'tel-line-full' : ''}`}
    >
      {icon 
        ? <FontAwesomeIcon icon={icon} className="opacity-60"/> 
        : <span className="tel-label" ref={labelRef}>{tel.lib_telephone}</span>
      }
      <span className="tel-number">{tel.phone_number}</span>
    </a>
  )
}

const MobileEffective = ({ searchBar, seasonSelect }) => {
  const { selectedSeason } = useContext(dataApplicationsContext);
  
  const { data: usersP, isLoading: isLoadingUsersP, isSuccess: isSuccessUsersP } = useGetAllUsersForPresenceQuery(
    selectedSeason?.value, { skip: !selectedSeason , refetchOnMountOrArgChange: true,}
  ); 

  const [search, setSearch] = useState('');
  const [ongletActif, setOngletActif] = useState(1);
  const [displayUsers, setDisplayUsers] = useState([]);

  const onglets = [{ label: 'Téléphones', value: 1 }, { label: 'Droit images', value: 2 }, { label: 'Allergies', value: 3 }];

  useEffect(() => {
    if (isSuccessUsersP) {
      let result = usersP.filter(u => !u.is_coach_assistant);

      // Filtre par recherche texte
      if (search.length > 0) {
        const normalizeString = (str) => {
          return str?.toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''); // Supprime les accents
        };

        const normalizedSearch = normalizeString(search);
        const includesSearch = (str) => {
          const normalizedStr = normalizeString(str);
          return normalizedStr?.includes(normalizedSearch);
        };
        result = result.filter((user) => {
          return (
            includesSearch(user.last_name) 
            || includesSearch(user.first_name)
            || includesSearch(user?.birth_date?.split('T')?.[0])
            || includesSearch(user.adresse)
          );
        });
      }

      // Filtre par onglet actif
      if (ongletActif === 3) {
        // Allergies : uniquement ceux qui ont au moins une allergie
        result = result.filter((user) => Array.isArray(user.allergies) && user.allergies.length > 0);
      } else if (ongletActif === 2) {
        // Droit images : uniquement ceux qui ont refusé
        result = result.filter((user) => user.is_image_aggreed === false);
      }

      setDisplayUsers(result);
    }
  }, [search, isSuccessUsersP, usersP, selectedSeason, ongletActif]);
  

  if (isLoadingUsersP) {
    return <SyncLoader color='#e1004a' size={12} className="mt-16 pl-48"/>
  }

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearch(value);
  }

  const handleReset = () => {
    setSearch('')
  }
    
  return (
    <div className="pl-8 pr-8 pt-6">
      <div className="search-container w-full mb-4">
        <i className={'bi bi-search input-icon'}></i>
        <input  
          type={'text'} className={`search-input`} autoComplete="off" autoCorrect="off" 
          placeholder={'Rechercher'} value={search} onChange={handleSearch}
        />
        {search.length > 0 && <i className="bi bi-x-lg close-search" onClick={handleReset}></i>}
      </div>
      {seasonSelect}
      <div className="onglet-container mt-5 mb-12">
        {onglets.map(o => {
          const isActive = ongletActif === o.value ? 'active' : '';
          return (
            <p key={o.value} className={`onglet ${isActive}`} onClick={() => setOngletActif(o.value)}>{o.label}</p>
          ) 
        })}
      </div>
      <div className="mobile-effective-container user-part">
        {displayUsers.map((user, index) => {
          const key = user.id_user ? `user-${user.id_user}-${index}` : `guest-${user.id_user_guest}-${index}`;
          return (
            <div key={key} className="mobile-effective-container-line" data={key}>
              <p className="font-semibold text-lg mb-0">{user.last_name} {user.first_name}</p>
              {ongletActif === 1 && (
                <div className="user-tel-line">
                  {user.telephones?.map((tel, index) => (
                    <TelLine 
                      key={`tel-${user.id_user || user.id_user_guest}-${index}`} 
                      tel={tel} 
                    />
                  ))}
                </div>
              )}
              {ongletActif === 2 && (
                <div className="user-image-refused-line">
                  <span className="image-refused-tag">Droit à l'image refusé</span>
                </div>
              )}
              {ongletActif === 3 && (
                <div className="user-allergie-line">
                  {user.allergies?.map((al, index) => (
                    <span key={`allergie-${user.id_user}-${index}`} className="allergie-tag">
                      {al.allergie_value}
                    </span>
                  ))}
                </div>
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default MobileEffective